<template>
  <div class="row status_table">
    <div class="col-12 profile_status_header">
      {{ getTranslations.home_profile_profile_edit_set_profile_picture }}
    </div>
    <div class="avatar_pool_outer">
      <div class="avatar_pool_inner">
        <img :class="[(selectedAvatar === 0) ? 'selected_avatar' : '']"
             @click.prevent="changeSelectedAvatar(0)"
             style="cursor: pointer"
             src="/static/images/avatar-default.svg" />
        <img v-for="imageIndex in numberOfAvatarImages"
             :class="[(selectedAvatar === imageIndex) ? 'selected_avatar' : '']"
             style="cursor: pointer"
             @click.prevent="changeSelectedAvatar(imageIndex)"
             :key="imageIndex"
             :src="getAvatarImage(imageIndex)" />
      </div>
    </div>
    <div class="row profile_edit_button_selection_options">
      <div class="col-12 profile_edit_connect_button"
           v-if="hasFbButton()">
        <facebook-login :enteredUsername="userDetails.username"
                        :errorsInFb="errorInConnectFb"
                        @errorsUpdated="methodForEvent($event)"
                        :type="fbActionType">
        </facebook-login>
        <span class="custom_fb_error_msg"
              v-if="errorInConnectFb">{{ getTranslations.home_store_this_fb }}
          </span>
      </div>
      <div class="col-12 profile_edit_select_button">
        <a :class="['ti_btn--green', selectedAvatar === '' ? 'deactivated' : '']"
           style="cursor: pointer"
           @click.prevent="changeAvatar()">
          {{ getTranslations.home_profile_profile_edit_select }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import FacebookLogin from '@/components/visitor/FacebookLogin';

export default {
  name: 'edit-avatar',
  data() {
    return {
      selectedAvatar: '',
      numberOfAvatarImages: 30,
      errorInConnectFb: false,
      fbActionType: 'connect',
    };
  },
  components: {
    FacebookLogin,
  },
  created() {
    if (!this.userAvatar) this.selectedAvatar = 0; // default
    this.setProfilePath(true);
  },
  methods: {
    ...mapActions('common', [
      'sendAvatarCall',
    ]),
    ...mapMutations('common', [
      'setProfilePath',
    ]),
    methodForEvent(event) {
      this.errorInConnectFb = event;
    },
    getAvatarImage(imageIndex) {
      let gender = 'male';
      let realIndex = imageIndex;
      const halfImages = this.numberOfAvatarImages / 2;
      if (halfImages < imageIndex) {
        gender = 'female';
        realIndex = imageIndex - halfImages;
      }
      return `/static/images/avatar_${this.avatarGrouping}/Avatar_${realIndex}_${gender}.png`;
    },
    getGender(imagePath) {
      if (imagePath.includes('default')) return this.userDetails.avatarGender;
      return imagePath.includes('female') ? 'female' : 'male';
    },
    changeAvatar() {
      let newAvatarPath = '/static/images/avatar-default.svg';
      if (this.selectedAvatar) newAvatarPath = this.getAvatarImage(this.selectedAvatar);
      localStorage.setItem('Avatar', newAvatarPath);
      this.sendAvatarCall(this.getGender(newAvatarPath));
    },
    changeSelectedAvatar(index) {
      this.selectedAvatar = index;
    },
    hasFbButton() {
      return this.$route.path === '/home/profile/edit'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userAvatar',
      'userDetails',
      'profilePath',
      'facebookFunctionality',
      'avatarGrouping',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/EditAvatar.vue